import React, { useMemo } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import GeneralEventSideBar from "components/events/ReplaySearchSidebar/GeneralEventSideBar";
const ReplaySearchSidebar = ({ alertId, definitionId = void 0 }) => {
  const sideBarDetailsPlugin = usePluginEntities("views.components.eventReplay.sideBarDetails");
  const EventSideBarDetails = useMemo(() => {
    const sideBarDetails = sideBarDetailsPlugin[0];
    const hasPlugin = typeof (sideBarDetails == null ? void 0 : sideBarDetails.useCondition) === "function" ? sideBarDetails.useCondition() : true;
    if (hasPlugin && !!(sideBarDetails == null ? void 0 : sideBarDetails.component)) return sideBarDetails.component;
    return GeneralEventSideBar;
  }, [sideBarDetailsPlugin]);
  return /* @__PURE__ */ React.createElement(EventSideBarDetails, { alertId, definitionId });
};
export default ReplaySearchSidebar;
